import { Component, OnInit, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { PageBase } from 't4core';
import { AppIntegrationService } from 't4-app-integration';
import { NavigationService } from 'app-components';

@Component({
    selector: 'app-cameraPermissionRequired',
    templateUrl: './cameraPermissionRequired.html',
    standalone: false
})
export class CameraPermissionRequired extends PageBase implements OnInit {

  @Input() permissionAsked: boolean = false;

  @Output()
  public next: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  public permissionAskedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(el: ElementRef, private appService: AppIntegrationService, private aviationService: NavigationService) {
    super(el);
  }
  public async ngOnInit() {
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  public ngOnDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  private onVisibilityChange = async () => {
    if (document.visibilityState === 'visible') {
      const res = await this.appService.requestDeviceState(); 
    }
  };

  public async askForPermission() {
    var res = await this.appService.ensureCameraAccess();
    if(res) this.next.emit(true);
    this.permissionAsked = true;
    this.permissionAskedChange.emit(this.permissionAsked);
  }

  public openSettings() {
    this.appService.openPermissions();

  }

  public skipTakePictures() {
    if (this.appService.Device.Camera < 2) {
      this.aviationService.executeCommand("Confirm");
    }
  }
}
